import React, { useState } from 'react'
import ButtonWithLoader from '../../components/ButtonWithLoader'
import InputControl from '../../components/InputControl'
import { Controller, useForm } from 'react-hook-form'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { statemanagement, industrymanagement, faqsubcategory, faq } from '../../Routes/routingConsts'
import { Dropdown, Form, InputGroup, Button } from 'react-bootstrap'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import ckeditor, { CKEditor } from '@ckeditor/ckeditor5-react'
import requestApi from '../../utils/request'
import { useMutation, useQuery } from 'react-query'
import Swal from 'sweetalert2'
import { ReactComponent as BackIcon } from '../../assets/images/left-arrow.svg'
import DropDownControlForLocation from '../../components/DropDownControlForLocation'
import DropDownControlForCategery from '../../components/DropDownControlForCategery/DropDownControlForCategery'
import DropDownControlForSubCategery from '../../components/DropDownControlForSubCategery/DropDownControlForSubCategery'
import ReactPlayer from 'react-player'

const ViewFaq = () => {
    const FaqCategoryValidationInput = yup.object({
        question: yup.string().trim().required('Please enter question'),
        videoUrl: yup.string().trim().required('Please enter video Url').url('Invalid URL'),
        description: yup
            .string()
            .trim()
            .required('Please enter job description'),
        categoryId: yup.object().required('Please select category'),
        subCategoryId: yup.object().required('Please select sub category'),
    })
    const {
        handleSubmit,
        reset,
        register,
        control,
        formState: { errors }
    } = useForm({ resolver: yupResolver(FaqCategoryValidationInput) })
    const navigate = useNavigate()
    const { faqId } = useParams()
    console.log('faqId',faqId)
console.log(errors,"errors")

    // add - edit state ///
   
    async function addEditFaq({location, ...payload }) {
        console.log(payload,"payload")
        if (faqId) {
            return await requestApi
                .post(
                    `faq/add-edit`,
                        {...payload,faqId},
                    { headers: true }
                )
                .then((res) => {
                    return res.data
                })
        } else {
            // let locationName = JSON.parse(location)
            return await requestApi
                .post(
                    `faq/add-edit`,
                    
                        payload
                    ,
                    { headers: true }
                )
                .then((res) => {
                    return res.data
                })
        }
    }
    const mutation = useMutation(addEditFaq, {
        onSuccess: (data) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                allowOutsideClick: false,
                text: data?.meta?.message
            }).then(() => {
                navigate(faq)
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })

     // view-faq on id //
     async function viewfaqOnId() {
        return await requestApi
            .post(`/faq/view`, { faqId }, { headers: true })
            .then((res) => {
                return res.data
            })
    }
    const { data, isLoading } = useQuery({
        queryKey: ['view-state'],
        queryFn: () => viewfaqOnId(faqId),
        enabled: !!faqId,
        onSuccess: ({data}) => {
            console.log(data,'data')
            reset({
                description: data?.description,
                videoUrl: data?.videoUrl,
                question: data?.question,
                categoryId: {
                    categoryId: data?.CategoryId,
                    categoryName: data?.CategoryName
                },
                subCategoryId: {
                    subCategoryId: data?.subCategoryId,
                    subCategoryName: data?.subCategoryName
                },
            })
        },
        onError: (error) => {
            if(error.message !== null){
                navigate(faq)
            }
            console.log(error, 'errorerror')
        }
    })

    // end view faq on id //

    ///// list category Api ////
    const [categoryDataListID, setCategoryDataListID] = useState('')
    console.log('categoryDataListID',categoryDataListID)
    async function countryList() {
        return await requestApi.post(
            `faqCategory/list`,
            { limit: 550 },
            { headers: true }
        )
    }
    const { data: categoryDataList } = useQuery({
        queryKey: ['faqCategory'],
        queryFn: () => countryList('country')
        // enabled: !!userProfile
    })

    //Sub Category API

    const [subCategoryDataListValue, setSubCategoryDataListValue] = useState('')
    console.log('subCategoryDataListValue', subCategoryDataListValue)
    const handleCategoryChange = async (selectedOption) => {
        try {
          // Call the API using async/await
          const response = await requestApi.post(
            `faq/get-faq-category-sub-category`,
            { categoryId: selectedOption.categoryId },
            { limit: 550 },
            { headers: true }
          );
      
          // Handle the API response here
          const subCategoryDataList = response; // Assuming the response has a 'data' property containing the result
          setSubCategoryDataListValue(subCategoryDataList)
          console.log('Subcategory data:', subCategoryDataList);
      
          // Update state or do anything with the subCategoryDataList here
          // For example, you can set it in the state or pass it to another function
        } catch (error) {
          // Handle any errors here, such as logging or showing an error message
          console.error('Error fetching sub-category data:', error);
        }
      }; 


    /////end category list api ///


    const onSubmit = ({ ...data }) => {
        console.log('datadatadata',data)
        const payload = {
            categoryId: data.categoryId.categoryId,
            subCategoryId: data.subCategoryId.subCategoryId,
            question: data.question,
            description: data.description,
            videoUrl: data.videoUrl,
        } 
        mutation.mutate(payload)
        console.log("dhngkghjkfhgjh",payload);
    }
    return (
        <>
            <div className="sidebar-content">
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <div className="whitebox">
                        <div className="previous-page-icon" style={{padding: '10px 20px 0px'}}>
                            <Link to={faq}>
                                <span className="back-btn" style={{margin: '0px'}}>
                                    <BackIcon className="back-icon" style={{transform: 'rotate(0deg)'}} />
                                    Back
                                </span>
                            </Link>
                        </div>
                        <div className="title-text">
                            <h3>View FAQ</h3>
                        </div>
                        <div className="createnew-box newbox">
                            <div className="row">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                                    <div className="faq-bottom-margin input-wrapper" style={{display: 'flex', alignItems: 'center'}}>  
                                        <h4>Category Name :</h4>
                                        <p style={{fontSize: '16px', paddingLeft: '10px'}}>{data?.data?.CategoryName}</p>
                                    </div>
                                </div>

                                <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                                    <div className="faq-bottom-margin input-wrapper" style={{display: 'flex', alignItems: 'center'}}>  
                                        <h4>Sub Category Name :</h4>
                                        <p style={{fontSize: '16px', paddingLeft: '10px'}}>{data?.data?.subCategoryName}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="whitebox">
                        <div className="createnew-box newbox">
                            <div className="row">
                                <div className="col-xl-12 col-lg-12 col-md-6 col-12">
                                    <div className="faq-bottom-margin input-wrapper" style={{display: 'flex', alignItems: 'center'}}>  
                                        <h4>Question :</h4>
                                        <p style={{fontSize: '16px', paddingLeft: '10px'}}>{data?.data?.question}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="whitebox">
                            <div className="title-text">
                                <h3>Description</h3>
                            </div>
                            <div className="dec" style={{padding: '25px'}}>
                                <div dangerouslySetInnerHTML={{__html:data?.data?.description}}></div>
                            </div>
                        </div>

                    {/* <div className="whitebox">
                        <div className="createnew-box newbox">
                            <div className="row">
                                <div className="col-xl-12 col-lg-12 col-md-6 col-12">
                                    <div className="mb-3 input-wrapper">
                                        <InputControl
                                            label="Video Url"
                                            name="videoUrl"
                                            register={register}
                                            // placeholder='State Name'
                                            error={errors?.videoUrl?.message}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {data?.data?.videoUrl !== '' && <div className="whitebox">
                        <div className="imageView" style={{padding: '25px'}}>
                            {/* <iframe width="100%" height="445" src={viewBlogData?.videoUrl}></iframe> */}
                            <ReactPlayer url={data?.data?.videoUrl} width="100%" height="500px" />
                        </div>
                    </div>}
                    
                </Form>
            </div>
        </>
    )
}

export default ViewFaq

